export default __webpack_public_path__ + "static/media/HiddenIcon.150c7449.svg";